import React from 'react';
import PropTypes from 'prop-types';

import { Button as Btn } from 'semantic-ui-react';

import './TooltipButton.css';


const TooltipButton = ({
  children,
  onClick,
  disabled,
  className,
  positive,
  negative,
}) => {
  const calculateClassName = () => {
    let value = 'tooltip-button__component';
    if (className) { value += ` ${className}`; }
    if (negative) { value += ' negative'; }
    if (positive) { value += ' positive'; }
    return value;
  };

  return (
    <Btn
      className={calculateClassName()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Btn>
  );
};

TooltipButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  positive: PropTypes.bool,
  negative: PropTypes.bool,
}

TooltipButton.defaultProps = {
  onClick: null,
  disabled: null,
  className: null,
  positive: null,
  negative: null,
}

export default TooltipButton;
